<main class="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
  <!-- Conditional rendering for each tab component -->
  <app-advanced-search *ngIf="isActiveTab('advanced-search')"></app-advanced-search>
   <app-previews *ngIf="isActiveTab('previews')"></app-previews>
  <app-bookings *ngIf="isActiveTab('bookings')"></app-bookings>
  <app-my-properties *ngIf="isActiveTab('my-properties')"></app-my-properties>
  <app-my-contracts *ngIf="isActiveTab('my-contracts')"></app-my-contracts>
  <app-comparison *ngIf="isActiveTab('comparison')"></app-comparison>
  <app-alerts *ngIf="isActiveTab('alerts')"></app-alerts>
  <app-seeker-profile *ngIf="isActiveTab('profile')"></app-seeker-profile>
  <app-my-installments *ngIf="isActiveTab('my-installments')"></app-my-installments>
  <app-seeker-tickets *ngIf="isActiveTab('my-tickets')"></app-seeker-tickets>
</main>
